// extracted by mini-css-extract-plugin
module.exports = {"container":"sticky-event_container__XiuoB","item":"sticky-event_item__HvkDM"};